import React from 'react';
import { Layout } from '../components/Layout';
import { Card } from '../components/ui/Card';
import { useTranslation } from '../i18n';
export function PatientPrivacyNoticePage() {
  const {
    t
  } = useTranslation();
  return <Layout data-id="element-2923">
      <section className="bg-teal-900 text-white py-16" data-id="element-2924">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-2925">
          <h1 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-2926">
            Patient Privacy Notice
          </h1>
          <p className="text-teal-100" data-id="element-2927">Last updated: 5 February 2026</p>
        </div>
      </section>

      <section className="py-16 bg-gray-50" data-id="element-2928">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2929">
          <Card className="p-8 md:p-12 prose prose-teal max-w-none" data-id="element-2930">
            <p className="lead" data-id="element-2931">
              Dentico Dental Clinic Ltd is responsible for your personal data.
            </p>

            <h3 data-id="element-2932">
              When you request an appointment or become our patient, we may
              collect:
            </h3>
            <ul data-id="element-2933">
              <li data-id="element-2934">contact details,</li>
              <li data-id="element-2935">appointment and administrative details,</li>
              <li data-id="element-2936">
                relevant health information needed to provide safe dental care.
              </li>
            </ul>

            <h3 data-id="element-2937">We use your data to:</h3>
            <ul data-id="element-2938">
              <li data-id="element-2939">provide dental care and manage appointments,</li>
              <li data-id="element-2940">communicate about treatment and follow-up,</li>
              <li data-id="element-2941">
                comply with legal, regulatory, and professional obligations.
              </li>
            </ul>

            <h3 data-id="element-2942">Data Sharing</h3>
            <p data-id="element-2943">
              We do not sell your data. We may share data with trusted providers
              (e.g. booking/IT systems, laboratories, advisers) where necessary
              and lawful.
            </p>

            <h3 data-id="element-2944">Your Rights</h3>
            <p data-id="element-2945">
              You have data protection rights under UK law, including access,
              correction, objection/restriction, and withdrawal of consent where
              consent is used.
            </p>

            <div className="bg-teal-50 p-6 rounded-xl mt-8 not-prose" data-id="element-2946">
              <h3 className="text-lg font-bold text-teal-900 mb-4" data-id="element-2947">
                Contact Us
              </h3>
              <div className="space-y-2 text-teal-800" data-id="element-2948">
                <p data-id="element-2949">
                  <strong data-id="element-2950">Email:</strong>{' '}
                  <a href="mailto:info@denticoclinic.co.uk" className="hover:underline" data-id="element-2951">
                    info@denticoclinic.co.uk
                  </a>
                </p>
                <p data-id="element-2952">
                  <strong data-id="element-2953">Address:</strong> 360–364 City Road, London EC1V 2PY
                </p>
                <p data-id="element-2954">
                  <strong data-id="element-2955">Phone:</strong> +44 7345 197820
                </p>
              </div>
            </div>
          </Card>
        </div>
      </section>
    </Layout>;
}